export default "__VITE_ASSET__02498b3d__"